import { useEffect, useState } from "react";
  import { getDatabase, ref, onValue, get, set, update } from "firebase/database";

  export default function UserMessages() {

    /* -------------------------
      FIX UID (VERY IMPORTANT)
    ------------------------- */
    let uid = localStorage.getItem("uid");

    if (!uid) {
      uid = "USER_" + Date.now(); // unique user
      localStorage.setItem("uid", uid);
    }

    const [messages, setMessages] = useState([]);
    const [joinedAt, setJoinedAt] = useState(null);

    /* -------------------------
      GET USER JOIN TIME
    ------------------------- */
    useEffect(() => {
      const db = getDatabase();
      const userRef = ref(db, `users/${uid}/joined_at`);

      get(userRef).then((snapshot) => {
        if (snapshot.exists()) {
          setJoinedAt(snapshot.val());
        } else {
          const now = Date.now();
          setJoinedAt(now);
          set(userRef, now); // save first open
        }
      });
    }, [uid]);

    /* -------------------------
      LOAD MESSAGES
    ------------------------- */
    useEffect(() => {
      if (!uid || joinedAt === null) return;

      const db = getDatabase();
      const msgRef = ref(db, "admin_messages");
      const readRef = ref(db, `admin_message_reads/${uid}`);

      onValue(msgRef, async (snapshot) => {
        const allMessages = [];

        snapshot.forEach((child) => {
          allMessages.push({
            messageId: child.key,
            ...child.val(),
          });
        });

        const readSnap = await get(readRef);
        const readMap = readSnap.exists() ? readSnap.val() : {};

        // ✅ FINAL FILTER (ANDROID MATCH)
       const filtered = allMessages.filter((msg) => {
  if (!msg.timestamp) return false;

  const isActive = msg.active === true;
  const isUnread = !readMap[msg.messageId];
  const isNew = msg.timestamp > joinedAt; // ⭐ FIX

  return isActive && isUnread && isNew;
});

        // latest first
        filtered.sort((a, b) => b.timestamp - a.timestamp);

        setMessages(filtered);
      });

    }, [uid, joinedAt]);

    /* -------------------------
      MARK ALL AS READ
    ------------------------- */
    const handleMarkAsRead = async () => {
      if (!messages.length) return;

      const db = getDatabase();
      const updates = {};

      messages.forEach((msg) => {
        updates[`admin_message_reads/${uid}/${msg.messageId}`] = true;
      });

      await update(ref(db), updates);

      setMessages([]);
    };

    const renderBody = (text) => {
      if (!text) return null;

      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const parts = text.split(urlRegex);

      return parts.map((part, i) => {
        if (part.match(urlRegex)) {
          return (
            <a
              key={i}
              href={part}
              target="_blank"
              rel="noreferrer"
              style={{ color: "#2563eb", textDecoration: "underline" }}
            >
              {part}
            </a>
          );
        }
        return <span key={i}>{part}</span>;
      });
    };
    return (
      <div style={{ maxWidth: "850px", margin: "40px auto", padding: "20px" }}>

        <h2 style={{ marginBottom: "20px" }}>📩 Admin Messages</h2>

        {messages.length === 0 ? (
          <div
            style={{
              padding: "40px",
              textAlign: "center",
              background: "#f9fafb",
              borderRadius: "12px",
            }}
          >
            No new messages
          </div>
        ) : (
          messages.map((msg) => (
            <div
              key={msg.messageId}
              style={{
                background: "#fff",
                padding: "20px",
                marginBottom: "15px",
                borderRadius: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                borderLeft: "5px solid #2563eb",
              }}
            >
              <h4>{msg.title}</h4>
              <p>{renderBody(msg.body)}</p>

              <small>
                {new Date(msg.timestamp).toLocaleString()}
              </small>
            </div>
          ))
        )}

        {messages.length > 0 && (
          <div style={{ textAlign: "right", marginTop: "20px" }}>
            <button
              onClick={handleMarkAsRead}
              style={{
                padding: "10px 18px",
                background: "#2563eb",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Mark All as Read
            </button>
          </div>
        )}
      </div>
    );
  }